import React from 'react';
import { useParams } from 'react-router-dom';
import { useGetTeamById, useUpdateTeamSettings } from '../api/teamsApi';
import { toast } from 'react-toastify';
import { TeamForm } from '../components/team/TeamForm';
import { BackButton } from '../components/common/BackButton';


function TeamSettings() {
  const { id: teamId, slug } = useParams();

  const { data: teamDataResp, isLoading } = useGetTeamById(teamId);
  const updateTeamSettings = useUpdateTeamSettings();

  const initial = teamDataResp?.data
    ? {
        teamName: teamDataResp.data.name || "",
        kitColor: teamDataResp.data.kitColor || "#ffffff",
        logoPreview: teamDataResp.data.logo || null,
      }
    : { teamName: "", kitColor: "#ffffff" };

  const handleSave = async (payload) => {
    try {
      await updateTeamSettings.mutateAsync({ id: teamId, ...payload });
      toast.success("Team settings updated successfully");
    } catch (err) {
      console.error("Error updating team settings", err);
      toast.error("Failed to update settings. Please try again.");
    }
  };

  return (
    <div className="page-login page-settings">
      <div className="wrapper">
        <h1>TEAM SETTINGS</h1>
        <BackButton fallbackPath={slug ? `/${slug}/team-pitch/${teamId}` : undefined} />
        {isLoading ? (
          <p>Loading…</p>
        ) : (
          <div className="form-block">
            <TeamForm initialValues={initial} onSubmit={handleSave} submitLabel="SAVE CHANGES" />
          </div>
        )}
      </div>
    </div>
  );
}

export { TeamSettings };
